import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_LoggedIn/attendance/session/$sessionId')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/attendance/session/$sessionId"!</div>
}
